import styled from "styled-components";
import { colorMixin } from "../../../helpers";
import { TColor } from "../../../types";

/**
 * @internal
 */
export const ProgressBarBackground = styled.div<{ $progressBackgroundColor: TColor }>`
    flex: 1;
    position: relative;
    overflow: hidden;

    width: 100%;
    min-height: 8px;

    border-radius: 4px;
    background-color: ${({ $progressBackgroundColor }) => colorMixin($progressBackgroundColor)};
`;

ProgressBarBackground.displayName = "ProgressBarBackground";

/**
 * @internal
 */
export const ProgressBarProgress = styled.div<{ $progress: number; $progressColor: TColor }>`
    position: absolute;

    height: 100%;
    width: ${({ $progress }) => Number($progress.toFixed(2))}%;

    border-radius: 4px;
    background-color: ${({ $progressColor }) => colorMixin($progressColor)};

    transition: width 150ms ease-in-out, background-color 150ms ease-in-out;
`;

ProgressBarProgress.displayName = "ProgressBarProgress";
